import {Injectable} from '@angular/core';

@Injectable()
export class BrowserDetect {
  public browser: string;
  public version: number;
  public OS: string;

  private versionSearchString: string;

  dataBrowser: Array<any> = [
    {
      string: navigator.userAgent,
      subString: 'Chrome',
      identity: 'Chrome'
    },
    {
      string: navigator.userAgent,
      subString: 'OmniWeb',
      versionSearch: 'OmniWeb/',
      identity: 'OmniWeb'
    },
    {
      string: navigator.vendor,
      subString: 'Apple',
      identity: 'Safari',
      versionSearch: 'Version'
    },
    {
      prop: navigator.userAgent,
      identity: 'Opera',
      versionSearch: 'Version'
    },
    {
      string: navigator.vendor,
      subString: 'iCab',
      identity: 'iCab'
    },
    {
      string: navigator.vendor,
      subString: 'KDE',
      identity: 'Konqueror'
    },
    {
      string: navigator.userAgent,
      subString: 'Firefox',
      identity: 'Firefox'
    },
    {
      string: navigator.vendor,
      subString: 'Camino',
      identity: 'Camino'
    },
    {		// for newer Netscapes (6+)
      string: navigator.userAgent,
      subString: 'Netscape',
      identity: 'Netscape'
    },
    {
      string: navigator.userAgent,
      subString: 'MSIE',
      identity: 'Explorer',
      versionSearch: 'MSIE'
    },
    {
      string: navigator.userAgent,
      subString: 'Trident',
      identity: 'Explorer',
      versionSearch: 'rv'
    },
    {
      string: navigator.userAgent,
      subString: 'Gecko',
      identity: 'Mozilla',
      versionSearch: 'rv'
    },
    { 	// for older Netscapes (4-)
      string: navigator.userAgent,
      subString: 'Mozilla',
      identity: 'Netscape',
      versionSearch: 'Mozilla'
    }
  ];

  dataOS: Array<any> = [
    {
      string: navigator.platform,
      subString: 'Win',
      identity: 'Windows'
    },
    {
      string: navigator.platform,
      subString: 'Mac',
      identity: 'Mac'
    },
    {
      string: navigator.userAgent,
      subString: 'iPhone',
      identity: 'iPhone/iPod'
    },
    {
      string: navigator.platform,
      subString: 'Linux',
      identity: 'Linux'
    }
  ];

  constructor() {
    this.browser = this.searchString(this.dataBrowser) || 'An unknown browser';
    this.version = this.searchVersion(navigator.userAgent)
      || this.searchVersion(navigator.appVersion)
      || -1;
    this.OS = this.searchString(this.dataOS) || 'an unknown OS';
  }

  searchString(data) {
    for (let i = 0; i < data.length; i++) {
      const dataString = data[i].string;
      const dataProp = data[i].prop;
      this.versionSearchString = data[i].versionSearch || data[i].identity;
      if (dataString) {
        if (dataString.indexOf(data[i].subString) !== -1) {
          return data[i].identity;
        }
      } else if (dataProp) {
        return data[i].identity;
      }
    }
  }

  searchVersion(dataString): number {
    const index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return null;
    }
    return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
  }

  downloadFile(fileUrl: string): void {
    let windowReference;
    if (this.browser === 'Safari') {
      windowReference = window.open();
      if (windowReference != null) {
        windowReference.location.href = fileUrl;
      }
    } else {
      window.open(fileUrl);
    }
  }

  downloadFileWithName(fileUrl: string, fileName: string): void {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = fileUrl;
    link.click();
    setTimeout(() => {
      try {
        link.remove();
      } catch (e) {
        // Do nothing
      }
    }, 10);
  }
}
